module.exports = __webpack_public_path__ + "static/img/flowPath.4d37680b.png";